import script from "./Badge.vue?vue&type=script&lang=ts&setup=true"
export * from "./Badge.vue?vue&type=script&lang=ts&setup=true"

import "./Badge.vue?vue&type=style&index=0&id=7a272a6b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a272a6b"]])

export default __exports__